import { TblCol, TblColType, TblSort, TblSortDir, TblFltOption } from './table.types';
import { tableSortVM } from './table_view_models';

// SECTION / VIEW
export type TblSectionSpec = {
    title: string;
    cols: string[];
};

// COLUMUN
export type TblColSpecOptions = {
    type?: TblColType;
    title?: string;
    width?: string;
    hasSort?: boolean;
    hasFilter?: boolean;
    fltOptions?: TblFltOption[];
    required?: boolean;
    tooltip?: string | ((row: any) => string);
};

// column map builder
export function tblSpecAddColumn<T>(
    map: Map<T, TblCol>,
    key: T,
    opt: TblColSpecOptions,
    renderer?: ({ item, colKey }: { item: any; colKey: string }) => JSX.Element,
): void {
    const newCol: TblCol = {
        key: key as string,
        type: !!opt.type ? opt.type : 'TEXT',
        title: !!opt.title ? opt.title : (key as string),
        width: !!opt.width ? opt.width : '',
        hasSort: opt.hasSort === false ? false : true, // default to true
        hasFilter: opt.hasFilter === false ? false : true, // default to true
        fltOptions: Array.isArray(opt.fltOptions) ? opt.fltOptions : [],
        renderer,
        required: typeof opt.required === 'boolean' ? opt.required : false,
        tooltip: opt.tooltip,
    };
    map.set(key as T, newCol);
}

// column spec to onSort change
export function tblSpecSetSort(key: string, cols: TblCol[], dir?: TblSortDir): TblSort {
    // get col spec here - don't pass the full spec around the components
    const foundColumn = cols.find(c => {
        return c.key == key;
    });
    if (foundColumn) {
        return {
            col: foundColumn.key,
            dir: !!dir ? dir : 'ASC',
        };
    } else {
        return tableSortVM();
    }
}

// column spec to onFilter change
export function tblSpecSetFilter(filters: Record<any, any>, key: string, cols: TblCol[], val?: any): object {
    const flt = filters[key];
    if (flt) {
        // strip out the undefined/nonexistant filter value
        if (typeof val === 'undefined' || val === '') {
            const { [key]: _, ...restFilters } = filters;
            filters = restFilters;
        } else {
            filters[key] = val;
        }
    } else {
        // get col spec here - don't pass the full spec around the components
        const foundColumn = cols.find(c => {
            return c.key == key;
        });
        if (foundColumn) {
            filters[key] = val ?? '';
        }
    }

    return filters;
}
